import { initializeApp } from 'firebase/app'; 
import { getFirestore } from 'firebase/firestore'; 

const firebaseConfig = {
  apiKey: "AIzaSyA26yGH-_n91qT_g5TxAuIltcla3ObK7ME",
  authDomain: "eventzy-c4fb4.firebaseapp.com",
  projectId: "eventzy-c4fb4",
  storageBucket: "eventzy-c4fb4.firebasestorage.app",
  messagingSenderId: "12107556913",
  appId: "1:12107556913:web:b78de8a2f45d411e770d10"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
